module.exports = "/_next/static/images/icon-twitter-e505187558fa938beead79175e0d9764.svg";